import { combineReducers } from "@reduxjs/toolkit";
import v3GamesSlice from './v3Games'
import v3GamesTableSlice from './v3GamesTableStore'
import v3GameProfileSlice from './v3GameProfile'
import { RootState } from "..";

export const selectorV3GamesTable = (state: RootState) => state.v3Games.table

export const selectorV3GameEntity = (state: RootState) => state.v3Games.entity

export const selectV3GameProfile = (state: RootState) => state.v3Games.profile


export const v3GamesReducer = combineReducers({
  table: v3GamesTableSlice,
  profile: v3GameProfileSlice,
  entity: v3GamesSlice
})